var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main info"},[_c('div',{staticClass:"page-content"},_vm._l((_vm.list),function(item){return _c(item.name,{key:item.id,tag:"component",attrs:{"data":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }